<template>
  <div class="list">
    <div class="flex-b-c" style="width: 100%" :class="{'action':currentindex === index}">
      <div style="width:32px; border-right: 1px solid #d7ecf3;">{{index+1}}</div>
      <div class="flex-d-b-c" style="width: calc(100% - 32px);">
        <div style="padding: 4px 0px; width: calc(100% - 8px)" class="flex-b-c">{{planid.name}}</div>
        <div style="padding: 4px 0px; width: calc(100% - 8px)" class="flex-b-c">
          <template v-if="plantype==0">
            <template v-if="this.$pstore.state.finaldata[index].radio=='count'">
              <div class="count">
                <span class="co" v-if="planid.count!=0">{{$t('schedule.playCount')}}:{{planid.count}}</span>
                <span class="co" v-else>{{$t('schedule.playCount')}}:{{planid.my_countvalue}}</span>
              </div>
            </template>
            <template v-if="this.$pstore.state.finaldata[index].radio=='time'">
              <div class="count">
                <span class="co" v-if="planid.time!=0">播放时长:{{`${planid.time}:00:00`}}</span>
                <span class="co" v-else>播放时长:{{`${planid.my_timevalue}`}}</span>
              </div>
            </template>
          </template>

          <template v-if="plantype==2">
            <div class="count">
              <span class="co" v-if="planid.count!=0">{{$t('schedule.playCount')}}:{{planid.count}}</span>
              <span class="co" v-else>{{$t('schedule.playCount')}}:{{planid.my_countvalue}}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- <div class="no">
      <span>{{index+1}}</span>
    </div>
    <div class="name">
      <span class="co">{{planid.name}}</span>
    </div> -->
    <!-- <div class="count">
			<span class="co">播放{{planid.count}}次</span>
		</div> -->
    <!-- <template v-if="plantype==0">
      <template v-if="this.$pstore.state.finaldata[index].radio=='count'">
        <div class="count">
          <span class="co" v-if="planid.count!=0">{{$t('schedule.playCount')}}:{{planid.count}}</span>
          <span class="co" v-else>{{$t('schedule.playCount')}}:{{planid.my_countvalue}}</span>
        </div>
      </template>
      <template v-if="this.$pstore.state.finaldata[index].radio=='time'">
        <div class="count">
          <span class="co" v-if="planid.time!=0">播放时长:{{`${planid.time}:00:00`}}</span>
          <span class="co" v-else>播放时长:{{`${planid.my_timevalue}`}}</span>
        </div>
      </template>
    </template>

    <template v-if="plantype==2">
      <div class="count">
        <span class="co" v-if="planid.count!=0">{{$t('schedule.playCount')}}:{{planid.count}}</span>
        <span class="co" v-else>{{$t('schedule.playCount')}}:{{planid.my_countvalue}}</span>
      </div>
    </template> -->

  </div>
</template>

<script>
export default {
  name: 'ProgramListItems',
  props: {
    planid: {
      type: Object
    },
    index: {
      type: Number
    },
    plantype: {
      type: Number
    },
    currentindex: {
      type: Number
    },
  },
}
</script>

<style lang="scss" scoped>
.action {
  background: #edfbff;
}
.list {
  border: 1px solid #d7ecf3;
  margin: 8px;
  text-align: center;
  width: calc(100% - 16px);
  display: flex;
  text-align: center;
  border-radius: 5px;
  min-height: 32px;
  // background-color: lightgrey;
  cursor: pointer;
}
.no {
  flex-basis: 15%;
}
.name {
  flex-basis: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.count {
  flex-basis: 45%;
}
</style>
